<template>
  <section class="r-item-page">
    <ac-data-table
      :headers="headers"
      :items.sync="items"
      :item-class="row_class"
      sort-by="key.string"
      item-key="key.value"
      fixed-header
      :footer-props="footer"
      :items-per-page="50"
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Items"
    >
      <template #actions>
          <v-btn @click="row_create" class="ma-2" color="primary">
            New Item
          </v-btn>
          <v-btn @click="show_preview" class="ma-2" color="accent">
            Preview JSON
          </v-btn>
      </template>

      <template #bulk-extra>
        <v-btn
          x-small
          class="ma-2 white--text"
          color="blue"
          :disabled="!bulkMode || selected.length === 0"
          @click="bulkCopy"
        >
          Bulk Copy
          <span v-if="selected.length"> ({{ selected.length }})</span>
        </v-btn>
      </template>

      <template v-slot:item.icon="{item}">
        <v-image-view style="width: 50px;height: 50px" :path="item_image(item)"/>
      </template>

      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_convert(item)" class="mr-2" small color="blue">mdi-cloud-upload-outline</v-icon>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-item-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
    <r-bulk-copy-dialog ref="bulkCopyDialog"/>

    <v-overlay :value="bulkCopyLoading" z-index="999">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
  </section>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {ItemModel} from "@/modules/redactor/models/item/ItemModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {serialize, deserialize} from "serializr";
import {uuid} from "vue-uuid";

import VImageView from "@/views/com/ImageView";
import RItemDialog from "@/modules/redactor/views/item/r-item-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";
import RBulkCopyDialog from "@/components/Dialog/r-bulk-copy-dialog.vue";

export default {
  name: "r-item-page",

  components: {RDialogPreviewCollection, AcDataTable, RItemDialog, VImageView, RBulkCopyDialog},

  data: () => ({
    search: "",
    headers: [
      {text: "Icon", value: "icon", sortable: false},
      {text: "Name", value: "key.string"},
      {text: "Key", value: "key.value"},
      {text: "Offer", value: "config.offerConfig.offer"},
      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(ItemModel)
    },
    selected: [],
    bulkMode: false,
    bulkCopyLoading: false,
    footer: {
      "items-per-page-options": [10, 50, 100, -1]
    }
  }),

  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },

  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy()).then(
          result => {

            if (this.items.find(v => v.key.equal(result.key))) {
              this.$alert("Duplicate item!");
            } else {
              RedactorUtils.pushItem(result).then(
                  () => {
                    this.$alert("Changes was published");
                  });
            }
          }).catch(() => {
      });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushItem(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone()).then(
          result => {
            RedactorUtils.pushItem(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkItems(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushItem(result);
    },
    row_convert(item) {
      this.$confirm("Are you sure you want to move this item to global config?")
          .then(() => {
            RedactorUtils.convertItem(item.clone())
                .then(() => {
                  this.$alert("Changes was published", "Convert To Global", "success");
                })
                .catch((error) => {
                  this.$alert(error, "Convert To Global", "error");
                });
          });
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    item_image(item) {
      if (item && item.key) {
        return 'assets/items/' + item.key.value + '.png'
      } else {
        return "";
      }
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, ItemModel, "item")
          .then(() => this.$alert("Changes was published"));
    },

    async bulkCopy() {
      if (!this.selected || this.selected.length === 0) {
        this.$alert("No items selected");
        return;
      }

      try {
        const { search, replace } = await this.$refs['bulkCopyDialog'].show(this.selected.length);

        this.bulkCopyLoading = true;

        const copiedItems = [];
        const errors = [];
        let successCount = 0;
        let autoCreatedKind = null;
        const createdKinds = new Set(); // Track which kinds we've already created
        const skippedKinds = new Set(); // Track kinds user declined to create

        // Create a regex for case-insensitive global replacement
        const searchRegex = new RegExp(search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');

        // Track all items including newly copied ones
        const allItems = [...this.items];

        for (const item of this.selected) {
          try {
            // Step 1: Serialize the original item to plain JSON
            const originalJson = serialize(ItemModel, item);

            // Step 2: Convert to JSON string and do replacement
            let jsonString = JSON.stringify(originalJson);

            // Check if kind will change and auto-create if needed
            const oldKindKey = originalJson?.key?.kind;

            if (oldKindKey && searchRegex.test(oldKindKey)) {
              searchRegex.lastIndex = 0;
              const newKindKey = oldKindKey.replace(searchRegex, replace);
              searchRegex.lastIndex = 0;

              // Check if new kind exists or was already created in this session
              let newKind = RedactorUtils.getItemKindByKey(newKindKey);
              if (!newKind && !createdKinds.has(newKindKey)) {
                // Ask user for confirmation before creating a new kind
                try {
                  await this.$confirm(`Item kind "${newKindKey}" does not exist. Create it automatically?`);
                } catch {
                  // User cancelled - skip all items with this kind
                  skippedKinds.add(newKindKey);
                  continue;
                }

                const originalKind = RedactorUtils.getItemKindByKey(oldKindKey);
                if (originalKind) {
                  newKind = originalKind.copy();
                  newKind._key = newKindKey;
                  newKind._enabled = true;

                  const allKinds = RedactorUtils.getItemKinds();
                  const maxCode = Math.max(...allKinds.map(k => k.code || 0));
                  newKind._code = maxCode + 1;

                  try {
                    await RedactorUtils.pushItemKind(newKind);
                    createdKinds.add(newKindKey);
                    autoCreatedKind = newKindKey;
                  } catch (kindError) {
                    errors.push(`Failed to create kind "${newKindKey}": ${kindError.message}`);
                    continue;
                  }
                } else {
                  errors.push(`Cannot create kind "${newKindKey}": original kind "${oldKindKey}" not found.`);
                  continue;
                }
              } else if (skippedKinds.has(newKindKey)) {
                // User previously declined creating this kind - skip
                continue;
              }
            }
            searchRegex.lastIndex = 0;

            // Do the replacement on the entire JSON
            jsonString = jsonString.replace(searchRegex, replace);
            searchRegex.lastIndex = 0;

            // Step 3: Parse back to JSON object
            const modifiedJson = JSON.parse(jsonString);

            // Validate that key exists in JSON
            if (!modifiedJson.key) {
              errors.push(`Key missing in JSON for ${item?.key?.value || 'item'}. JSON: ${jsonString.substring(0, 200)}`);
              continue;
            }

            // Validate that kind exists in registry
            if (modifiedJson.key.kind) {
              const kindCheck = RedactorUtils.getItemKindByKey(modifiedJson.key.kind);
              if (!kindCheck) {
                errors.push(`Kind "${modifiedJson.key.kind}" not found in registry for ${item?.key?.value || 'item'}.`);
                continue;
              }
            }

            // Step 4: Generate a new UID (like copy() does)
            modifiedJson.uid = uuid.v4().replace(/-/g, "");
            modifiedJson.export = false;
            modifiedJson.global = false;

            // Step 5: Deserialize back to ItemModel
            const copiedItem = deserialize(ItemModel, modifiedJson);

            // Step 6: Validate the item
            if (!copiedItem) {
              errors.push(`Deserialization failed for ${item?.key?.value || 'item'}.`);
              continue;
            }

            if (!copiedItem.key) {
              errors.push(`Copied item has no key for ${item?.key?.value || 'item'}.`);
              continue;
            }

            if (!copiedItem.key.valid()) {
              errors.push(`Copied item key is invalid for ${item?.key?.value || 'item'}. Kind: ${copiedItem.key.kind?.key}, Level: ${copiedItem.key.level}`);
              continue;
            }

            if (!copiedItem.valid()) {
              errors.push(`Copied item failed validation for ${item?.key?.value || 'item'}.`);
              continue;
            }

            // Step 7: Find first available level for the kind
            const kind = copiedItem.key.kind;
            let maxLevel = 100; // default max
            if (kind && kind.levels && Array.isArray(kind.levels) && kind.levels.length > 0) {
              maxLevel = Math.max(...kind.levels);
            }

            // Start at level 0 and find first available level
            let foundLevel = false;
            for (let testLevel = 0; testLevel <= maxLevel; testLevel++) {
              copiedItem.key.level = testLevel;
              const isDuplicate = allItems.find(v => v.key && copiedItem.key && v.key.equal && v.key.equal(copiedItem.key));
              if (!isDuplicate) {
                foundLevel = true;
                break;
              }
            }

            if (!foundLevel) {
              errors.push(`Cannot copy ${item?.key?.value || 'item'}: all levels (0-${maxLevel}) are already taken for kind ${kind?.key || 'unknown'}.`);
              continue;
            }

            copiedItems.push(copiedItem);
            allItems.push(copiedItem);
            successCount++;
          } catch (error) {
            const itemName = item?.key?.value || 'unknown item';
            errors.push(`Error copying item ${itemName}: ${error.message}`);
          }
        }

        // Step 8: Push all successfully copied items
        if (copiedItems.length > 0) {
          for (const copiedItem of copiedItems) {
            try {
              await RedactorUtils.pushItem(copiedItem);
            } catch (pushError) {
              errors.push(`Error pushing item ${copiedItem?.key?.value || 'unknown'}: ${pushError.message}`);
            }
          }
        }

        // Show summary
        let message = `Successfully copied ${successCount} item(s)`;
        if (autoCreatedKind) {
          message += `\n\nAuto-created new item kind: "${autoCreatedKind}"`;
        }
        if (errors.length > 0) {
          message += `\n\nErrors:\n${errors.join('\n')}`;
        }

        this.$alert(message, "Bulk Copy", errors.length > 0 ? "warning" : "success");

        // Clear selection
        this.selected = [];
        this.bulkMode = false;

      } catch (error) {
        if (error.message !== "Cancelled") {
          this.$alert(error.message, "Bulk Copy Error", "error");
        }
      } finally {
        this.bulkCopyLoading = false;
      }
    }
  },

  created() {
    this.items = RedactorUtils.getItems();
  }
}
</script>
